import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiUpdateTask, type UpdateTaskPatch } from '../api/tasks.api';

export function useUpdateTask(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ taskId, patch }: { taskId: string; patch: UpdateTaskPatch }) =>
            apiUpdateTask(projectId, taskId, patch),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks', projectId] }),
    });
}
